<form [formGroup]="form" (submit)="submitForm()">
  <mat-card class="p-4 w-7 mx-auto bg-grey-button form-enrollment-verification">
    <div class="edit-field my-1">
      <label for="studentName">Student Name</label>
      <input
        id="studentName"
        matInput
        formControlName="studentName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_name_input"
        data-qa="edit_student_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="studentPID">Student PID</label>
      <input
        id="studentPID"
        matInput
        formControlName="studentPid"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_pid_input"
        data-qa="edit_student_pid_input" />
    </div>
    <div class="edit-field my-1">
      <label for="school">School</label>
      <input
        id="school"
        matInput
        formControlName="schoolName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_school_input"
        data-qa="edit_school_input" />
    </div>
    <div class="form-enrollment-verification__checkbox-field my-4">
      <label for="part-time">Will your student attend this school full-time?</label>
      <mat-slide-toggle id="part-time" formControlName="isFullTime" class="mx-3"
        data-pw="is_full_time_toggle"
        data-qa="is_full_time_toggle">
        {{ form.get('isFullTime')?.value ? 'Yes' : 'No' }}
      </mat-slide-toggle>
    </div>

    @if (isPartTime) {
      <div class="edit-field my-1">
        <label for="coEnrollmentType">Co-Enrollment Type</label>
        <mat-form-field>
          <mat-select
            id="coEnrollmentType"
            placeholder="Please Select"
            formControlName="coEnrollmentType"
            data-pw="edit_co_enrollment_type_input"
            data-qa="edit_co_enrollment_type_input">
            @for (type of coEnrollmentTypes; track type.coEnrollmentTypeId) {
              <mat-option [value]="type.coEnrollmentTypeId"> {{ type.name + ' - ' + type.description }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <cfi-form-inline-error [control]="form.get('coEnrollmentType')" />
      </div>
    }
    @if (!form.disabled) {
      <div class="button-row">
        <button
          mat-stroked-button
          type="button"
          color="primary"
          (click)="onBack()"
          data-pw="cancel_button"
          data-qa="cancel_button">
          Cancel
        </button>
        <button
          mat-flat-button
          type="submit"
          [disabled]="!isFormReady()"
          color="primary"
          data-pw="submit_button"
          data-qa="submit_button">
          Submit
        </button>
      </div>
    }
  </mat-card>
</form>
